import { BaseBonusBoardDrawer } from './BaseBonusBoardDrawer';

export class BonusBoardLandscapeDrawer extends BaseBonusBoardDrawer {

}
